// Frontend Console Logging Wrapper (CVE-016 Fix)
// Prevents sensitive error information from appearing in production console

const isProd = import.meta.env.PROD;  // Vite: true in production build

export const logger = {
    error: (...args) => {
        if (!isProd) {
            console.error(...args);
        }
        // In production, you could send to error tracking service here
        // e.g., Sentry.captureException(args[0])
    },

    warn: (...args) => {
        if (!isProd) {
            console.warn(...args);
        }
    },

    log: (...args) => {
        if (!isProd) {
            console.log(...args);
        }
    },

    info: (...args) => {
        if (!isProd) {
            console.info(...args);
        }
    }
};

// For debugging, always show
export const debugLog = (...args) => {
    if (import.meta.env.VITE_DEBUG === 'true') {
        console.log('[DEBUG]', ...args);
    }
};
